import { render, staticRenderFns } from "./PausedServerAlertsTable.vue?vue&type=template&id=348e6aa1&"
import script from "./PausedServerAlertsTable.vue?vue&type=script&lang=js&"
export * from "./PausedServerAlertsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports